export class ComprovacaoFilterDTO {
    ano:String;
	opcaoEnvio:String;
	matricula:String;
	nomeFuncionario:String;
	dataInicio:Date;
	dataFinal:Date;
    page:number;
}
